const enquiredDataB2b = (xmlElement) => {
    const EnquiredData = xmlElement.getElementsByTagName("cb:EnquiredData")[0];
    const SubjectRefDate = EnquiredData?.attributes.SubjectRefDate?.value ?? '';
    const companyRoot = EnquiredData?.getElementsByTagName('cb:Company')[0];
    // attributes company
    const LegalForm = companyRoot?.attributes?.LegalForm?.value ?? '';
    const LegalFormDesc = companyRoot?.attributes?.LegalFormDesc?.value ?? '';
    const Rating = companyRoot?.attributes?.Rating?.value ?? '';
    const RatingInstitution = companyRoot?.attributes?.RatingInstitution?.value ?? '';
    const RatingInstitutionDesc = companyRoot?.attributes?.RatingInstitutionDesc?.value ?? '';
    // attributes company anme
    const TradeName = companyRoot?.getElementsByTagName('cb:CompanyName')[0]?.attributes?.TradeName?.value ?? '';
    // attributes CompanyEstablishment
    const CompanyEstablishment = companyRoot?.getElementsByTagName('cb:CompanyEstablishment')[0];
    const PlaceOfEstablishment = CompanyEstablishment?.attributes?.PlaceOfEstablishment?.value ?? '';
    const DeedNumberOfEstablishment = CompanyEstablishment?.attributes?.DeedNumberOfEstablishment?.value ?? '';
    const DeedDateOfEstablishment = CompanyEstablishment?.attributes?.DeedDateOfEstablishment?.value ?? '';
    const RecentlyeOfEstablishment = CompanyEstablishment?.attributes?.RecentlyeOfEstablishment?.value ?? '';
    const DateofFinalAmendmentDeedNumber = CompanyEstablishment?.attributes?.DateofFinalAmendmentDeedNumber?.value ?? '';
    // attributes Address
    const Address = companyRoot?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.Address?.value ?? ''
    const SubDistrict = companyRoot?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.SubDistrict?.value ?? ''
    const District = companyRoot?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.District?.value ?? ''
    const City = companyRoot?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.City?.value ?? ''
    const PostalCode = companyRoot?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.PostalCode?.value ?? ''
    const Country = companyRoot?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.Country?.value ?? ''
    const CityDesc = companyRoot?.getElementsByTagName("cb:AddressDesc")[0].attributes.CityDesc?.value ?? '-'
    const CountryDesc = companyRoot?.getElementsByTagName("cb:AddressDesc")[0].attributes.CountryDesc?.value ?? ''
    // attributes BusinessIdentificationCode
    const BusinessIdentityNumber = companyRoot?.getElementsByTagName("cb:BusinessIdentificationCode")[0].attributes.BusinessIdentityNumber?.value ?? ''
    // attributes Contact
    const PhoneNumber = companyRoot?.getElementsByTagName("cb:Contact")[0].attributes.PhoneNumber?.value ?? ''
    const CellphoneNumber = companyRoot?.getElementsByTagName("cb:Contact")[0].attributes.CellphoneNumber?.value ?? ''
    const EmailAddress = companyRoot?.getElementsByTagName("cb:Contact")[0].attributes.EmailAddress?.value ?? ''

    const results = {
        SubjectRefDate,
        LegalForm,
        LegalFormDesc,
        Rating,
        RatingInstitution,
        RatingInstitutionDesc,
        TradeName,
        PlaceOfEstablishment,
        DeedNumberOfEstablishment,
        DeedDateOfEstablishment,
        RecentlyeOfEstablishment,
        DateofFinalAmendmentDeedNumber,
        Address,
        SubDistrict,
        District,
        City,
        PostalCode,
        Country,
        CityDesc,
        CountryDesc,
        BusinessIdentityNumber,
        PhoneNumber,
        CellphoneNumber,
        EmailAddress,
    }
    return results;
}

export default enquiredDataB2b;
